__webpack_require__.p = "https://parcelhub.ae/monitoring/control-tower/";